'use client';

import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { EventNumber } from '@svs/nova-poolbetting/schema/sport';
import type { ReactNode } from 'react';

import { TipsinfoContainer, TipsinfoValuesContainer } from '@/components/index.browser';

type TipsinfoResultContainerProps = {
  eventNumber: EventNumber;
  drawNumber: DrawNumber;
  product: Definition['moduleEngine'];
};

/**
 * TipsinfoResultContainer component.
 *
 * @param root0 props
 * @param root0.eventNumber eventNumber for which to show tipsinfo
 * @param root0.drawNumber drawNumber for which to show tipsinfo
 * @param root0.product product to get tipsinfo for
 * @returns tipsinfo and tipsinfo values components for Results
 */
export function TipsinfoResultContainer({ eventNumber, drawNumber, product }: TipsinfoResultContainerProps): ReactNode {
  return (
    <div className="grid grid-cols-[auto_min-content]">
      <TipsinfoContainer
        product={product}
        eventNumber={eventNumber}
        drawNumber={drawNumber}
        settingsKey="RESULT"
        className=""
      />
      <TipsinfoValuesContainer
        className="mr-1.5 ml-1.5 w-fit min-w-37.5 justify-self-end"
        product={product}
        eventNumber={eventNumber}
        drawNumber={drawNumber}
        settingsKey="RESULT"
      />
    </div>
  );
}
